export default String.raw`
<g id="promoBanner1 Homepage/mobile">
    <rect width="360" height="787" class="bgColor"/>
    <g>
        <g>
            <rect x="16" y="24" width="328" height="391.557" rx="8" fill="white"/>
            <image x="16" y="24" width="328" height="391.557" rx="8" href="./img/previewElements/promoBannerDesktop_1.png" />
            <g>
                <text class="bannerPromotionalFontColor" fill="white" xml:space="preserve" style="white-space: pre" font-size="24" font-weight="600" letter-spacing="0px"><tspan x="40" y="72.7273">TRANSLATION_Prv_promoBannerTitle{1}</tspan><tspan x="40" y="104.727">TRANSLATION_Prv_promoBannerTitle{2}</tspan></text>
                <g>
                    <rect class="btnSolidBgColor" x="40" y="144" width="221" height="40" rx="5"/>
                    <text class="btnSolidTextColor" fill="white" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="120.764" y="169.091">TRANSLATION_Prv_Check</tspan></text>
                </g>
            </g>
        </g>
        <g>
            <g>
                <g>
                    <rect x="16" y="439.557" width="242" height="207" rx="4" fill="white"/>
                    <image preserveAspectRatio="xMidYMid meet" x="16" y="439.557" width="242" height="207" rx="4" href="./img/previewElements/newsSection_1.png" />
                </g>
            <g>
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="16" y="677.648">TRANSLATION_Prv_PromoBanner_KeyboardHyperRun</tspan></text>
            <g>
            <g>
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="16" y="733.648">310,67 zł</tspan></text>
                <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px" text-decoration="line-through"><tspan x="85" y="732.92">390,67 zł</tspan></text>
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="146" y="733.648">TRANSLATION_Prv_PromoBanner_Netto</tspan></text>
            </g>
            <g>
                <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="16" y="758.92">390,67 zł TRANSLATION_Prv_PromoBanner_LowestPriceThirtyDaysGross</tspan></text>
            </g>
        </g>
    </g>
</g>
<g>
    <g>
        <rect x="274" y="439.557" width="242" height="207" rx="4" fill="white"/>
        <image preserveAspectRatio="xMidYMid meet" x="274" y="439.557" width="242" height="207" rx="4" href="./img/previewElements/promoProduct_4.png" />
    </g>
    <g>
        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="274" y="677.648">TRANSLATION_Prv_PromoBanner_HeadphonesBlack</tspan></text>
        <g>
            <g>
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="274" y="733.648">310,67 zł</tspan></text>
                <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px" text-decoration="line-through"><tspan x="343" y="732.92">390,67 zł</tspan></text>
            </g>
            <g>
                <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="274" y="758.92">390,67 zł TRANSLATION_Prv_PromoBanner_LowestPriceThirtyDaysGross</tspan></text>
            </g>
        </g>
    </g>
</g>
`